import { render, staticRenderFns } from "./containerBill.vue?vue&type=template&id=0ba0f93d&scoped=true"
import script from "./containerBill.vue?vue&type=script&lang=js"
export * from "./containerBill.vue?vue&type=script&lang=js"
import style0 from "./containerBill.vue?vue&type=style&index=0&id=0ba0f93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0f93d",
  null
  
)

export default component.exports